export default __webpack_public_path__ + "static/media/backIcon.e4d030f5.png";